import axios from '@/utils/axios';

export const getFoodPoints = async ({ commit }, params) => {

    await axios({
        method: "GET",
        url: '/food_points',
        params: params
    })
        .then(response => {
            if (response.data) {
                const { data } = response;
                commit('setFoodPoints', data["hydra:member"]);
                commit('setTotalItems', data['hydra:totalItems']);
            }
        })
        .catch(e => {
            console.log(e);
        });
};

export const getFoodPointById = async ({ commit }, id) => {

    commit('setCurrentFoodPoint', null);

    await axios({
        method: "GET",
        url: `/food_points/${id}`
    })
        .then(response => {
            const { data } = response;
            commit('setCurrentFoodPoint', data);
        })
        .catch(e => {
            console.log(e);
        });
}

export const add = async (_, payload) => {

    return await axios({
        method: "POST",
        url: '/food_points',
        data: payload
    })
        .then(response => {
            console.log(response);
        })
        .catch(e => {
            console.log(e);
        });
};

export const edit = async ({ commit }, payload) => {

    return await axios({
        method: "PUT",
        url: '/food_points/' + payload['id'],
        data: payload,
    })
        .then((response) => {
            console.log(response);
            commit('setLoading', false);
        })
        .catch(e => {
            console.log(e);
        });
};

export const deleteFoodPoint = async ({ commit }, id) => {

    await axios({
        method: "DELETE",
        url: `/food_points/${id}`
    })
        .then(response => {
            console.log(response);
            commit('setLoading', false);
        })
        .catch(e => {
            console.log(e);
        });
};